



const FieldRequired =()=>{


    return (
        <div >
          <span className="Text Text-color--red Text-fontSize--11 Text-fontWeight--500 Text-transform--uppercase">
            <span role="alert" id="required-email-fieldset" data-qa="EmptyFieldError">
              Zorunlu
            </span>
          </span>
        </div>
      );
}
export default FieldRequired;